import Switch from './src/switch2.mjs';
export { switchEmits, switchProps } from './src/switch.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElSwitch = withInstall(Switch);

export { ElSwitch, ElSwitch as default };
//# sourceMappingURL=index.mjs.map
